import { createContext } from 'react';

import type { IQueryContext } from './models';

export const QueryParamsContext = createContext<IQueryContext>({});
